export class Polygon{
    static triangle = [
        0.0,1.0,0.0,
        1.0,0.0,0.0,
        -1.0,0.0,0.0
    ];
    static quad = [
        0.0,1.0,0.0,
        1.0,0.0,0.0,
        -1.0,0.0,0.0,
        0.0,-1.0,0.0];
    static quadIndice = [
        0,1,2,
        1,2,3
    ];
    static GenDonut = (innerRad:number,outerRad:number,div:number) => {
        let theta = 0;
        let vertices = [];
        let indices = [];
        for(let i = 0; i < div; i++){
            theta = 2*Math.PI*i/div;
            vertices.push(innerRad * Math.cos(theta),innerRad * Math.sin(theta),0.0);
            vertices.push(outerRad * Math.cos(theta),outerRad * Math.sin(theta),0.0);
        }
        for(let i = 0; i < div*2.0; i++){
            indices.push(i%(div*2.0));
            indices.push((i+1)%(div*2.0));
            indices.push((i+2)%(div*2.0));
        }
        return[vertices,indices];
    }
    static GenCross = (longer:number,shorter:number) => {
        let theta = 0;
        let vertices = [];
        let indices = [];
        vertices.push(longer,shorter,0.0);
        vertices.push(longer,-shorter,0.0);
        vertices.push(-longer,shorter,0.0);
        vertices.push(-longer,-shorter,0.0);
        vertices.push(shorter,longer,0.0);
        vertices.push(shorter,-longer,0.0);
        vertices.push(-shorter,longer,0.0);
        vertices.push(-shorter,-longer,0.0);
        indices.push(0,1,2,1,2,3);
        indices.push(4,5,6,5,6,7);
        return[vertices,indices];
    }

    static GenTube = (rad:number,divC:number) => {
        const vertices = [] as Array<number>;
        const indices = [] as Array<number>;
        for(let i = 0; i < 2; i++){
            const center = [0.0,0.0,i];
            const center_d= [0.0,0.0,i+1.0];
            const normal = [center_d[0]-center[0],center_d[1]-center[1],center_d[2]-center[2]];
            const n_l = Math.sqrt(normal[0]*normal[0]+normal[1]*normal[1]+normal[2]*normal[2]);
            normal[0] /= n_l;
            normal[1] /= n_l;
            normal[2] /= n_l;
            let vecA = [1.0,0.0,0.0];
            if(normal[1]*normal[1]+normal[2]*normal[2] > 0.0001){
                vecA = [0.0,-normal[2]/Math.sqrt(normal[1]*normal[1]+normal[2]*normal[2]),normal[1]/Math.sqrt(normal[1]*normal[1]+normal[2]*normal[2])];
            }
            const vecB = [normal[2]*vecA[1]-normal[1]*vecA[2],normal[0]*vecA[2]-normal[2]*vecA[0],normal[1]*vecA[0]-normal[0]*vecA[1]];
            for(let j = 0; j < divC; j++){
                const theta = 2 * Math.PI * j / divC;
                const vecR = [
                    center[0] + vecA[0] * (Math.cos(theta)*rad) + vecB[0] * (Math.sin(theta)*rad),
                    center[1] + vecA[1] * (Math.cos(theta)*rad) + vecB[1] * (Math.sin(theta)*rad),
                    center[2] + vecA[2] * (Math.cos(theta)*rad) + vecB[2] * (Math.sin(theta)*rad)
                ]
                vertices.push(vecR[0],vecR[1],vecR[2]);
            }
        }
        for(let i = 0; i < 1; i++){
            for(let j = 0; j < divC; j++){
                indices.push(i * divC + j,(i+1)*divC + j,i * divC + (j+1)%divC);
                indices.push(i * divC + (j+1)%divC,(i+1)*divC + j,(i+1) * divC + (j+1)%divC);
            }
        }
        return[vertices,indices];
    }

    static CreateVBO = (vertices:Array<number>,gl:WebGLRenderingContext) => {
        const vbo = gl.createBuffer();
        gl.bindBuffer(gl.ARRAY_BUFFER,vbo);
        gl.bufferData(gl.ARRAY_BUFFER,new Float32Array(vertices),gl.STATIC_DRAW);
        gl.bindBuffer(gl.ARRAY_BUFFER,null);
        return vbo;
    }
    static CreateIBO = (indices:Array<number>,gl:WebGLRenderingContext) => {
        const ibo = gl.createBuffer();
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,ibo);
        gl.bufferData(gl.ELEMENT_ARRAY_BUFFER,new Int16Array(indices),gl.STATIC_DRAW);
        gl.bindBuffer(gl.ELEMENT_ARRAY_BUFFER,null);
        return ibo;
    }

}